import { render, staticRenderFns } from "./Chart-Donut.vue?vue&type=template&id=07d19684&scoped=true&"
import script from "./Chart-Donut.vue?vue&type=script&lang=js&"
export * from "./Chart-Donut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d19684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d19684')) {
      api.createRecord('07d19684', component.options)
    } else {
      api.reload('07d19684', component.options)
    }
    module.hot.accept("./Chart-Donut.vue?vue&type=template&id=07d19684&scoped=true&", function () {
      api.rerender('07d19684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/charts/Chart-Donut.vue"
export default component.exports